import React from "react";
import BrainFinding from "./BrainFinding";

const WeatherPanel = ({ weather }) => {
  if (!weather) return null;
  const num = (v, suffix = "") => (v === null || v === undefined ? "—" : `${v}${suffix}`);
  const temp = (v) => (v === null || v === undefined ? "—" : `${Math.round(v)}°C`);
  const cell = (lab, val) => (
    <div className="wx-cell">
      <div className="c-lab">{lab}</div>
      <div className="c-val">{val}</div>
    </div>
  );

  return (
    <div className="panel entrance" data-testid="weather-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic" style={{ background: "linear-gradient(135deg,#1e6ea7,#2a92d6)" }}>
            <i className="fa-solid fa-cloud-sun-rain" />
          </div>
          Weather Feed
        </div>
        <span className={`pill ${weather.risk_level}`}>{weather.coverage_label}</span>
      </div>
      <BrainFinding tile="weather" />

      <div className="wx-top">
        <div className="wx-temp" style={{ color: "var(--head)" }}>
          <i className="fa-solid fa-cloud-showers-heavy" />
          {temp(weather.temperature_c)}
        </div>
        <div style={{ textAlign: "right" }}>
          <div className="rr-sub">Feels like</div>
          <div className="c-val" style={{ fontSize: 24 }}>{temp(weather.feels_like_c)}</div>
        </div>
      </div>

      <div className="wx-grid">
        {cell("Rain", num(weather.rain_mm, " mm"))}
        {cell("Wind", num(weather.wind_kmh, " km/h"))}
        {cell("Humidity", num(weather.humidity_pct, "%"))}
        {cell("Cloud", num(weather.cloud_pct, "%"))}
      </div>

      <div className="wx-summary">{weather.summary}</div>

      {weather.storm_status && weather.storm_status !== "none" && (
        <div className="wx-storm" data-testid="storm-alert">
          <i className="fa-solid fa-hurricane" />
          <div>
            <strong style={{ textTransform: "uppercase" }}>{weather.storm_status}</strong> — {weather.storm_summary}
          </div>
        </div>
      )}
    </div>
  );
};

export default WeatherPanel;
